import React from "react";
import QrGen from "../QrGen";

function MyQr() {
  return (
    <div>
      <QrGen />
    </div>
  );
}

export default MyQr;
